import React, { createContext, PropsWithChildren, ReactElement, useContext } from 'react';

import { Optional } from '@vimeo/core/types/generic';
import { TComposerSessionId } from '@vimeo/live-core/types/composer_session';

import { useRegistrantLoginCookie } from '../../../../hooks/live/useRegistrantLoginCookie';

interface IInteractionToolsStatusObserverProps {
  /**
   * Whether observer logic is active.
   */
  isActive?: boolean;
  /**
   * Session id of interaction room.
   */
  sessionId: TComposerSessionId;
  /**
   * Component to show if interaction room status is disabled.
   */
  placeholder?: Optional<ReactElement>;
}

/**
 * Context for specific case with usage of registrant observers as fast-login options.
 */
export const InteractionToolsRegistrantContext = createContext<Optional<string>>(null);

/**
 * Hook to get currently provisioned registrant.
 */
export function useInteractionToolsRegistrantUuid(): Optional<string> {
  return useContext(InteractionToolsRegistrantContext);
}

/**
 * For conditional rendering of chat and observing of active registrant.
 * Force rendering placeholder and wait for active registrant UUID.
 */
export function InteractionToolsRegistrantObserver({
  isActive = false,
  children,
  sessionId,
}: PropsWithChildren<IInteractionToolsStatusObserverProps>) {
  const registrantLoginCookie: Optional<string> = useRegistrantLoginCookie(
    isActive,
    sessionId as string,
  );

  return (
    <InteractionToolsRegistrantContext.Provider value={registrantLoginCookie}>
      {children}
    </InteractionToolsRegistrantContext.Provider>
  );
}
